var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarSmileyHappyFaceStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.43 -1.43 40 40",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-smiley-happy-face--calendar-smiley-happy-face-planner-schedule-behavior"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fill: "#ffffff",
    d: "M2.4482449242857145 27.993744428571432c0.44023899000000005 3.7808520000000003 3.632687275714286 6.782825142857143 7.580377461428571 6.965872285714286 2.7285962142857145 0.12654128571428572 5.515953214285715 0.19233214285714287 8.54111232857143 0.19233214285714287 3.025185642857143 0 5.812516114285715 -0.06579085714285715 8.541138857142856 -0.19233214285714287 3.9477167142857144 -0.18304714285714288 7.1401650000000005 -3.1850202857142857 7.580274000000001 -6.965872285714286 0.6114835714285715 -5.251649057142857 0.6114835714285715 -9.723756042857143 0 -14.975272457142859 -0.44010900000000003 -3.7810111714285717 -3.632557285714286 -6.783063900000001 -7.580274000000001 -6.966084514285715 -2.728622742857143 -0.12651475714285715 -5.515953214285715 -0.19227908571428573 -8.541138857142856 -0.19227908571428573 -3.025159114285714 0 -5.812516114285715 0.06576432857142857 -8.54111232857143 0.19227908571428573 -3.947690185714286 0.18302061428571428 -7.140138471428572 3.185073342857143 -7.580377461428571 6.966084514285715 -0.6114703071428572 5.251516414285715 -0.6114676542857144 9.723623400000001 0 14.975272457142859Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect_2",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.4482449242857145 27.993744428571432c0.44023899000000005 3.7808520000000003 3.632687275714286 6.782825142857143 7.580377461428571 6.965872285714286 2.7285962142857145 0.12654128571428572 5.515953214285715 0.19233214285714287 8.54111232857143 0.19233214285714287 3.025185642857143 0 5.812516114285715 -0.06579085714285715 8.541138857142856 -0.19233214285714287 3.9477167142857144 -0.18304714285714288 7.1401650000000005 -3.1850202857142857 7.580274000000001 -6.965872285714286 0.6114835714285715 -5.251649057142857 0.6114835714285715 -9.723756042857143 0 -14.975272457142859 -0.44010900000000003 -3.7810111714285717 -3.632557285714286 -6.783063900000001 -7.580274000000001 -6.966084514285715 -2.7285962142857145 -0.12651475714285715 -5.515953214285715 -0.19227908571428573 -8.541138857142856 -0.19227908571428573 -3.025159114285714 0 -5.812516114285715 0.06576432857142857 -8.54111232857143 0.19227908571428573 -3.947690185714286 0.18302061428571428 -7.140138471428572 3.185073342857143 -7.580377461428571 6.966084514285715 -0.6114703071428572 5.251516414285715 -0.6114676542857144 9.723623400000001 0 14.975272457142859Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 3",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m11.279815928571429 1.9896428571428573 0 7.295357142857143",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 4",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m25.86018407142857 1.9896428571428573 0 7.295357142857143",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 404",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13.783715142857144 16.29538722857143 0 1.3151539285714287",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 405",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m23.35888465714286 16.29538722857143 0 1.3151539285714287",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.698882271428573 23.233218814285713c0.8735593285714287 2.2475801571428575 2.8971322285714285 3.4707064714285716 5.8720197 3.4707064714285716s4.998460371428572 -1.2231263142857145 5.8720197 -3.4707064714285716",
    strokeWidth: 2.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSmileyHappyFaceStreamlineFlex);
export default __webpack_public_path__ + "static/media/Calendar-Smiley-Happy-Face--Streamline-Flex.e34064f99bdf487075bb5e8aaa869f7f.svg";
export { ForwardRef as ReactComponent };